//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        data() {
            return {
                video:null,
                canvas:null,
                context:null
            }
        },
        mounted() {
            this.aa();
        },
        methods: {
            //访问用户媒体设备的兼容方法
            getUserMedia(constraints, success, error) {
                console.log(success,error)
                if (navigator.mediaDevices.getUserMedia) {
                    //最新的标准API
                    navigator.mediaDevices.getUserMedia(constraints).then(success).catch(error);
                } else if (navigator.webkitGetUserMedia) {
                    //webkit核心浏览器
                    navigator.webkitGetUserMedia(constraints, success, error)
                } else if (navigator.mozGetUserMedia) {
                    //firfox浏览器
                    navigator.mozGetUserMedia(constraints, success, error);
                } else if (navigator.getUserMedia) {
                    //旧版API
                    navigator.getUserMedia(constraints, success, error);
                }
            },


            success(stream) {
                //兼容webkit核心浏览器
                let CompatibleURL = window.URL || window.webkitURL;
                //将视频流设置为video元素的源
                console.log(stream);

                //video.src = CompatibleURL.createObjectURL(stream);
                this.video.srcObject = stream;
                this.video.play();
            },

            error(error) {
                this.$alert('打开摄像头失败，或将您的IOS系统升级至14.5以上!', '标题名称', {
                    confirmButtonText: '确定',
                    callback: action => {

                    }
                });
                console.log(`访问用户媒体设备失败${error.name}, ${error.message}`);
            },

            aa() {
                this.video = document.getElementById('video')
                this.canvas = document.getElementById('canvas')
                if (navigator.mediaDevices.getUserMedia || navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia) {
                    //调用用户媒体设备, 访问摄像头
                    this.getUserMedia({video: {width: 480, height: 320,sourceId: 'default',facingMode: "user"}}, this.success, this.error);
                } else {
                    alert('不支持访问用户媒体');
                }
            },


            tackpic() {
                let context = this.canvas.getContext('2d')
                var that = this;
                context.drawImage(that.video, 0, 0, 480, 320);
                let base64Img = that.canvas.toDataURL('image/jpeg');
                // console.log(base64Img)
                // alert(base64Img)
                let imgfile = this.base64ToFile(base64Img,'File')

                this.$emit('getimgurl',imgfile)
                this.$EventBus.$emit('Brotherfunction',imgfile);
            },

            base64ToFile (dataurl,name) {
                const arr = dataurl.split(','); const mime = arr[0].match(/:(.*?);/)[1];
                const bstr = atob(arr[1]); let n = bstr.length;
                const u8arr = new Uint8Array(n);
                // eslint-disable-next-line no-plusplus
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                const suffix = mime.split('/');
                return new File([u8arr], name, { type: mime });
            }
        }
    }



// WEBPACK FOOTER //
// ./src/components/FaceRecognition.vue